import { ChannelLogListPage } from "@/features/channel-log/pages/ChannelLogListPage";
import { createFileRoute } from "@tanstack/react-router";

// Filters + pagination live in the URL so a filtered view is shareable and survives refresh/back.
export interface ChannelLogSearch {
	tab: string;
	direction: string;
	channel: string;
	operation: string;
	merchant: string;
	page: number;
	pageSize: number;
	view: string;
}

export const Route = createFileRoute("/admin/channel-log/")({
	validateSearch: (search: Record<string, unknown>): ChannelLogSearch => ({
		tab: search.tab === "sync" ? "sync" : "logs",
		direction: typeof search.direction === "string" ? search.direction : "",
		channel: typeof search.channel === "string" ? search.channel : "",
		operation: typeof search.operation === "string" ? search.operation : "",
		merchant: typeof search.merchant === "string" ? search.merchant : "",
		page: Number(search.page) > 0 ? Number(search.page) : 1,
		pageSize: Number(search.pageSize) > 0 ? Number(search.pageSize) : 10,
		view: typeof search.view === "string" ? search.view : "",
	}),
	component: ChannelLogListPage,
});
